// extracted by mini-css-extract-plugin
export default {"root":"Registered_root__LMMMZ","copyright":"Registered_copyright__XGM65"};